import { z } from 'zod'

export const registrationSchema = z.object({
  first_name: z.string().min(2, 'First name must be at least 2 characters').max(50),
  middle_name: z.string().max(50).optional().or(z.literal('')),
  last_name: z.string().min(2, 'Last name must be at least 2 characters').max(50),
  gender: z.string().min(1, 'Gender is required'),
  mobile_no: z
    .string()
    .regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number'),
  whatsapp_no: z
    .string()
    .regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number'),
  state: z.string().min(1, 'State is required'),
  district: z.string().min(1, 'District is required'),
  blood_group: z.string().optional().or(z.literal('')),
  ward_number: z.string().optional().or(z.literal('')),
  pincode: z
    .string()
    .regex(/^\d{6}$/, 'Enter a valid 6-digit pincode')
    .optional()
    .or(z.literal('')),
  full_address: z.string().optional().or(z.literal('')),
  dob: z.string().min(1, 'Date of birth is required'),
})

export type RegistrationFormData = z.infer<typeof registrationSchema>

export const loginSchema = z.object({
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(1, 'Password is required'),
})

export type LoginFormData = z.infer<typeof loginSchema>

export const userUpdateSchema = z.object({
  first_name: z.string().min(2).max(50),
  middle_name: z.string().max(50).optional().or(z.literal('')),
  last_name: z.string().min(2).max(50),
  gender: z.string().min(1),
  mobile_no: z.string().regex(/^[6-9]\d{9}$/),
  whatsapp_no: z.string().regex(/^[6-9]\d{9}$/),
  state: z.string().min(1),
  district: z.string().min(1),
  blood_group: z.string().optional().or(z.literal('')),
  ward_number: z.string().optional().or(z.literal('')),
  pincode: z.string().regex(/^\d{6}$/).optional().or(z.literal('')),
  full_address: z.string().optional().or(z.literal('')),
  dob: z.string().min(1),
})

export type UserUpdateData = z.infer<typeof userUpdateSchema>

export const notificationSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200),
  message: z.string().min(1, 'Message is required').max(2000),
  type: z.enum(['whatsapp', 'sms', 'both']),
  scheduled_at: z.string().optional(),
  filters: z
    .object({
      state: z.string().optional(),
      district: z.string().optional(),
      ward_number: z.string().optional(),
      age_min: z.number().optional(),
      age_max: z.number().optional(),
      date_from: z.string().optional(),
      date_to: z.string().optional(),
      user_ids: z.array(z.number()).optional(),
    })
    .optional(),
})

export type NotificationFormData = z.infer<typeof notificationSchema>
